// extracted by mini-css-extract-plugin
module.exports = {"body":"Panel_body__39KYI"};